import React, { ReactNode } from 'react';

// Material-ui
import { AppBar, Grid } from '@material-ui/core';

// Components
import Typography from '@components/UI-KIT/Typography';
import Button from '@components/UI-KIT/Button';

interface Props {
    expanded: boolean,
    title: string,
    createButton: { label: string, icon: ReactNode | null, action: () => void } | null,
    children: ReactNode
}

const ScreenHeader: React.FC<Props> = ({
    expanded = true,
    title,
    children = null,
    createButton = null
}) => {

    return (
        <>
            <AppBar
                className="ui-Screen-header"
            >
                <Grid
                    container
                    wrap="nowrap"
                    justify="space-between"
                    alignItems="center"
                    className={`ui-Header-component${expanded ? ' menu-expanded' : ' menu-collapsed'}`}
                >
                    { children || (
                        <>
                            <Typography
                                variant="h3"
                                color="primary-dark"
                                className="AOL-Header-title"
                            >
                                {title}
                            </Typography>
                            { createButton && (
                                <Button
                                    label={createButton.label}
                                    icon={createButton.icon}
                                    onClick={createButton.action}
                                    level={1}
                                />
                            )}
                        </>
                    )}
                </Grid>
            </AppBar>
        </>
    );
};

export default ScreenHeader;